import { render, staticRenderFns } from "./DemonstrativoFaturamento.vue?vue&type=template&id=0ded7831&scoped=true&"
import script from "./DemonstrativoFaturamento.vue?vue&type=script&lang=js&"
export * from "./DemonstrativoFaturamento.vue?vue&type=script&lang=js&"
import style0 from "./DemonstrativoFaturamento.vue?vue&type=style&index=0&id=0ded7831&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ded7831",
  null
  
)

export default component.exports